export const MINT_WIDGET_CTA = {
  MINT: 'Mint',
} as const;

export const MINT_WIDGET_LOADING_MESSAGE = {
  MINTING: 'Minting',
} as const;
